import ConnectionsEffectIcon from '@/components/Common/ConnectionsEffectIcon';
import callbackStatusMap from './callbackStatusMap';

// @vue/component
export default {
  name: 'CallbackListItem',

  components: {
    ConnectionsEffectIcon,
    callbackStatusMap,
  },

  props: {
    callback: {
      type: Object,
      default: () => ({}),
    },
    connectionEffectsList: {
      type: Object,
      default: () => ({}),
    },
    agentList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedAgent: '',
      isLoading: false,
      isAgentPopoverVisible: false,
      ifAnyConnectionIsInProgress: false,
      isCallbackButtonDisabled: false,
    };
  },
  created() {
    if (this.agentList.length === 1) {
      this.selectedAgent = this.agentList[0].uuid;
    }
  },
  computed: {
    callbackEffectName() {
      if(this.connectionEffectsList[this.callback.status]) {
        return this.connectionEffectsList[this.callback.status][0]?.effect_name;
      }
    },
    callbackEffectDescription() {
      if(this.connectionEffectsList[this.callback.status]) {
        return this.connectionEffectsList[this.callback.status][0]?.effect_description;
      }
    },
    callbackEffectColor() {
      if(this.connectionEffectsList[this.callback.status]) {
        return this.connectionEffectsList[this.callback.status][0]?.effect_color;
      }
    },
    callbackEffectIcon() {
      if(this.connectionEffectsList[this.callback.status]) {
        return this.connectionEffectsList[this.callback.status][0]?.effect_icon;
      }
    }
  },
  watch: {
    selectedAgent(newValue) {
      const selectedAgentDetails = this.agentList.filter(agent => agent.uuid.includes(newValue));
      if(this.checkIfTheSameNumbers(selectedAgentDetails[0].nr_tel)) {
        this.isCallbackButtonDisabled = true;
      } else {
        this.isCallbackButtonDisabled = false;
      }
    }
  },
  mounted() {
    this.$EventBus.$on('MakeCallPopover/IS_ANY_CALLING_RECORD', (record) => {
      this.ifAnyConnectionIsInProgress = record;
    });
  },

  beforeDestroy() {
    this.$EventBus.$off('MakeCallPopover/IS_ANY_CALLING_RECORD');
  },
  methods: {
    getLighterColorForStatus() {
      const color = require('color');
      return color(callbackStatusMap[this.callback.callback_status].color).lighten(0.55);
    },
    getDarkenColorForStatus() {
      const color = require('color');
      return color(callbackStatusMap[this.callback.callback_status].color).darken(0.3);
    },
    getTextForStatus() {
      return callbackStatusMap[this.callback.callback_status].text;
    },
    parsePhoneNumber(phoneNumber) {
      if (phoneNumber.length === 9 && phoneNumber.substr(0, 2) !== '48') {
        return '48'.phoneNumber;
      }
      return phoneNumber;
    },
    checkIfTheSameNumbers(agentNumber) {
      return this.agentList.length === 0 ? false : (this.parsePhoneNumber(this.callback.num_a) === this.parsePhoneNumber(agentNumber || this.agentList[0].nr_tel));
    },
    async checkIfAbleToCall(connectionUuid) {
      this.isLoading = true;
      this.isAgentPopoverVisible = false;
      const result = await this.$store.dispatch('callback/checkIfAnyoneIsCallingBack', connectionUuid);
      if (!result.isCalling) {
        this.$message({
          title: 'Sukces',
          message: 'Następuje próba oddzwaniania ',
          type: 'success',
        });

        const params = {
          agent: this.selectedAgent,
          number_b: this.callback.num_a,
          uuid: this.callback.wh1_uuid,
        };
        await this.$store.dispatch('user/agent/makeCall', params);

        const paramsForChangeCallbackStep = {
          isCalling: true,
          connectionUuid: this.callback.wh1_uuid,
          statusName: 'CALLED',
        };

        this.$store.commit('callback/UPDATE_LIST_BY_CALLBACK_STEP', paramsForChangeCallbackStep);

        this.isLoading = false;
      } else {
        this.$message({
          title: 'Sukces',
          message: 'Inny agent aktualnie oddzwania na ten numer',
          type: 'warning',
        });
        this.isLoading = false;
      }
    },
  },
};
